









































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'
    import ShelfUp from './product-shelfup.vue'
    import DeductCost from './headfee-add.vue'

    import storeaddressInfo from '@/store/entities/back-storeaddress-list';
    import DateUtils from '@/common/js/DateUtils'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);

    class PagebackstockRequest extends PageRequest {
        beginTime?: Date;
        endTime?: Date;
        isCheckBy?: boolean;
        logisticsNumber: string;
        storeId?: number;
        productSku: string;
        userCode: string;
    }

    @Component({
        name: "backstockList",
        components: { DeductCost, ShelfUp }
    })
    export default class backstock extends AbpBase {
        editModalShow: boolean = false;
        settingCostModalShow: boolean = false;
        deductModalShow: boolean = false;
        deductshelfcostModalShow: boolean = false;
        shelfupModalShow: boolean = false;
        storeaddressList: Array<storeaddressInfo> = [];
        pagerequest: PagebackstockRequest = new PagebackstockRequest();
        IsCheckedStatus = Enums.getEnum(Enums.IsCheckStatus, true);
        creationTime: Date[] = [];
        isArrived: boolean;
        isPrompt: boolean;
        createModalShow: boolean = false;
        get list() {
            return this.$store.state.backstock.list;
        };
        get loading() {
            return this.$store.state.backstock.loading;
        }
        async add() {
            this.createModalShow = true;
        }
        pageChange(page: number) {
            this.$store.commit('backstock/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('backstock/setPageSize', pagesize);
            this.getpage();
        }
        async searchPage() {
            this.$store.state.user.currentPage = 1;
            this.getpage();
        }
        async getpage() {

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters

            if (this.creationTime.length > 0) {
                this.pagerequest.beginTime = this.creationTime[0];
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.endTime = this.creationTime[1];
            }
            this.getData();
            await this.$store.dispatch({
                type: 'backstock/getAll',
                data: this.pagerequest
            })

        }

        async operationData(name: any, data: any) {

        }
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            this.storeaddressList.push(a);
        }
        async checkmodel(data: any) {
            this.$store.state.backstock.id = data.id;
            await this.$store.dispatch({
                type: 'backstock/isCheckPass',
                data: { id: data.id, ispass: true }
            })
            this.getpage();
        }
        async checknomodel(data: any) {
            //this.$store.state.backstock.id = data.id;
            await this.$store.dispatch({
                type: 'backstock/isCheckPass',
                data: { id: data.id, ispass: false }
            })
            this.getpage();
        }
        async warehosuesign(data: any, str: string) {
            if (str == "到达仓库") {
                await this.$store.dispatch({
                    type: 'backstock/EditStatus',
                    data: { id: data.id, isArrived: true }
                })
                this.getpage();
            }
            else {
                this.$store.state.backstock.id = data.id;
                this.$store.state.backstock.orderSite = data.orderSite;

                this.deductModalShow = true;
            }

        }
        async putShelf(data: any) {
            this.isPrompt = await this.$store.dispatch({
                type: 'backstock/ShelfUpCheck',
                data: { id: data.id }
            })
            if (this.isPrompt == false) {
                this.$Modal.warning({
                    title: "提示", content: "需要设置仓储费和设置单个产品上架费才能上架！", onOk: async () => {
                    }
                });
            }
            else {
                this.$store.state.backstock.id = data.id;

                this.shelfupModalShow = true;
            }
        }

        get pageSize() {
            return this.$store.state.backstock.pageSize;
        }
        get totalCount() {
            return this.$store.state.backstock.totalCount;
        }
        get currentPage() {
            return this.$store.state.backstock.currentPage;
        }
        columns = [
            {
                title: '备货信息',
                width: 240,
                render: (h: any, params: any) => {
                    var a = "red";
                    return h('div', [h('h3', "国内物流单号:" + (params.row.logisticsNumber == null ? "" : params.row.logisticsNumber)), h('h3', "打包件数:" + (params.row.packageNums == null ? "" : params.row.packageNums)), h('h3', { style: { color: a } }, "产品状态：" + (params.row.productStatus == null ? "" : Enums.ProductStatus.filter(function (item) { return item.value == params.row.productStatus })[0].name))])
                }
            },
            {
                title: '备货入库仓库',
                key: 'storeName',
                width: 150,
            },
            {
                title: '产品信息',
                width: 450,
                render: (h: any, params: any) => {
                    var a = "red";
                    return h('div', [h('h3', "类型:" + Enums.ProductType.filter(function (item) { return item.value == params.row.productType })[0].name), h('h3', "SKU:" + (params.row.productSku)), h('h3', "名称:" + (params.row.productName)), h('h3', "链接:" + (params.row.productLink)), h('h3', "数量:" + (params.row.productNums)), h('h3', "采购成本:" + (params.row.purchaseCost) + "元"), h('h3', { style: { color: a } }, "备注：" + (params.row.remark == null ? "" : params.row.remark))])
                }
            },
            //{
            //    title: '产品类型',
            //    width: 90,
            //    key: 'productType',
            //    render: (h: any, params: any) => {
            //        return h('span', Enums.ProductType.filter(function (item) { return item.value == params.row.productType })[0].name);
            //    }
            //    },
            {
                title: '产品图片',
                key: 'productImgGuid',
                width: 95,
                render: (h: any, params: any) => {
                    if (params.row.productImgGuid) {
                        var data = { imageGuid: params.row.productImgGuid, url: null };
                        this.$store.commit('expressuserinfo/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: "yc_" + params.row.id,
                                "preview-text": params.row.orderNumber + "cp"
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },
            //{
            //title: '产品Sku',
            //    key: 'productSku',
            //width: 80,
            //},
            {
                title: '用户编码',
                key: 'userCode',
                width: 90,
            },
            {
                title: '是否审核通过',
                key: 'isCheckBy',
                width: 120,
                render: (h: any, params: any) => {
                    return h('span', params.row.isCheckBy == null ? this.L('审核中') : (params.row.isCheckBy ? this.L('审核通过') : this.L('审核未通过')))
                }
            },
            //{
            //    title: '扣费详情',
            //    width: 280,
            //    render: (h: any, params: any) => {
            //        return h('div', [h('h3', "开始扣费时间:" + (params.row.beginDeductionTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.beginDeductionTime)))), h('h3', "扣费周期:" + (params.row.deductionCycle == null ? "" : params.row.deductionCycle + "天")), h('h3', "扣除积分/周期:" + (params.row.deductIntegral == null ? "" : params.row.deductIntegral + "积分")), h('h3', "上架费:" + (params.row.shelfCost == null ? "" : params.row.shelfCost + "积分"))])
            //    }
            //},

            {
                title: '打包数量',
                key: 'packageNums',
                width: 90,
            },
            //{
            //    title: '商品链接',
            //    key: 'productLink',            //{
            //    title: '开始扣费时间',
            //    key: 'beginDeductionTime',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.beginDeductionTime == null ? "" :DateUtils.formatLongDate(new Date(params.row.beginDeductionTime)));
            //    }
            //},
            //{
            //    title: '扣费积分',
            //    key: 'deductIntegral',
            //    width: 200,
            //},
            //{
            //    title: '扣费周期/积分',
            //    key: 'deductionCycle',
            //    width: 200,
            //},
            //    width: 200,
            //},
            //{
            //    title: '商品名称',
            //    key: 'productName',
            //    width: 200,
            //},
            //{
            //    title: '商品数量',
            //    key: 'productNums',
            //    width: 200,
            //},
            //{
            //    title: '采购成本',
            //    key: 'purchaseCost',
            //    width: 200,
            //},
            {
                title: '时间',
                width: 230,
                render: (h: any, params: any) => {
                    return h('div', [h('h3', "创建时间:" + (params.row.creationTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.creationTime)))), h('h3', "更新时间:" + (params.row.lastModificationTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.lastModificationTime)))), h('h3', "审核时间:" + (params.row.checkTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.checkTime))))])
                }
            },
            //{
            //title: '创建时间',
            //    key: 'creationTime',
            //width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', DateUtils.formatLongDate(new Date(params.row.creationTime)));
            //}
            //},
            //{
            //    title: '更新时间',
            //    key: 'lastModificationTime',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.lastModificationTime == null ? "" :DateUtils.formatLongDate(new Date(params.row.lastModificationTime)));
            //    }
            //},
            //{
            //   title: '备注',
            //   width: 220,
            //   key: 'reMark',
            // },
            {
                title: '操作',
                width: 120,
                fixed: 'left',
                key: 'id',
                render: (h: any, params: any) => {
                    var data = params.row;
                    var _this = this;
                    var ss = data.storeName.indexOf("国内")
                    var lable = "";
                    if (ss < 0) {
                        lable = "转海外";
                    }
                    else {

                        lable = "到达仓库";
                    }
                    //var menu = [];
                    //menu.push("审核通过");
                    //menu.push("审核未通过");
                    return h('div', [
                        //h('Dropdown', {
                        //    props: {
                        //        transfer: true,
                        //        trigger: 'click',
                        //    },
                        //    on: {
                        //        'on-click': (name) => {
                        //            _this.operationData(name, params.row);
                        //        }
                        //    }

                        //}, [
                        //    h('Button',
                        //        {
                        //            domProps: {
                        //                innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                        //            },
                        //            props: {
                        //                type: 'primary',
                        //            }

                        //        }),

                        //    h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                        //        return h('DropdownItem', { props: { name: item } }, item)
                        //    })
                        //    )],
                        //),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '80px',
                                height: '30px',
                                display: params.row.isCheckBy == null ? "inline-block" : "none",

                            },
                            on: {
                                click: () => {
                                    _this.checkmodel(params.row);

                                }
                            }

                        }, "审核通过"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '80px',
                                height: '30px',
                                display: params.row.isCheckBy == null ? "inline-block" : "none",

                            },
                            on: {
                                click: () => {
                                    _this.checknomodel(params.row);

                                }
                            }

                        }, "审核未通过"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '80px',
                                height: '30px',
                                display: params.row.productStatus == 0 ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {
                                    _this.warehosuesign(params.row, lable);

                                }
                            }

                        }, lable),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '80px',
                                height: '30px',
                                display: params.row.productStatus == 1 ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {

                                    _this.warehosuesign(params.row, "到达仓库");
                                }
                            }

                        }, "到达仓库"),
                        //h('Button', {
                        //    props: {
                        //        type: 'primary',
                        //        size: 'small',
                        //    },
                        //    style: {
                        //        marginTop: '5px',
                        //        width: '80px',
                        //        height: '30px',
                        //        display: params.row.productStatus == 2 ? "inline-block" : "none",
                        //    },
                        //    on: {
                        //        click: () => {
                        //            _this.deduct(params.row);

                        //        }
                        //    }

                        //}, "扣除上架费"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '80px',
                                height: '30px',
                                display: params.row.productStatus == 2 ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {
                                    _this.putShelf(params.row);

                                }
                            }

                        }, "上架"),


                    ]);

                }
            }
        ]
        async created() {

            this.getpage();
        }
    }
